export const JIRA_OUTBOX_QUERY_KEY = ['jira-outbox-status'] as const

export type JiraOutboxStatus = {
  degraded?: boolean
  pending_count?: number
  failed_count?: number
}

/** Header badge and Tasks import only when Jira is configured. */
export function jiraChromeVisible(status: JiraOutboxStatus | null | undefined): status is JiraOutboxStatus {
  return status != null && status.degraded !== true
}
